(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PasswordUpdateByLoginController', PasswordUpdateByLoginController);

    PasswordUpdateByLoginController.$inject = ['login', '$uibModalInstance', 'PasswordUpdateByLogin', 'AlertService'];

    function PasswordUpdateByLoginController (login, $uibModalInstance, PasswordUpdateByLogin, AlertService) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.account = {login: login};
        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                PasswordUpdateByLogin.changeUserPassword(vm.account.login, vm.password, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            console.log(result);
            $uibModalInstance.close(true);
            AlertService.success("password.messages.success");
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.error = 'ERROR';
            vm.isSaving = false;
        }

    }
})();
